<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="编号(MN)">
              <a-input placeholder="请输入编号(MN)" v-model="queryParam.mn"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称">
              <a-input placeholder="请输入名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>

          <!--          <a-col :md="6" :sm="8">-->
          <!--            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型">-->
          <!--              <a-input placeholder="请输入类型" v-model="queryParam.category"/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运营中心">
              <a-tree-select
                style="width: 100%"
                :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                :treeData="deptTree"
                v-model="queryParam.deptId"
                placeholder="请选择运营中心"
                show-search
                treeNodeFilterProp="title"
              >
                <template slot="title" slot-scope="{ title }"> ABC{{ title }}</template>
              </a-tree-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任人">
              <a-tree-select
                style="width: 100%"
                :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                :treeData="userTree"
                v-model="queryParam.userId"
                placeholder="请选择责任人"
                show-search
                treeNodeFilterProp="title"
              >
                <template slot="title" slot-scope="{ title }"> ABC{{ title }}</template>
              </a-tree-select>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8" v-if="showColumnState">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水体流域">
                <a-tree-select
                  style="width: 100%"
                  :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                  :treeData="riverTree"
                  v-model="queryParam.riverId"
                  placeholder="请选择水体流域"
                  show-search
                  treeNodeFilterProp="title"
                >
                  <template slot="title" slot-scope="{ title }"> ABC{{ title }}</template>
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8" v-if="!showColumnState">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称">
                <a-select
                  style="width: 100%"
                  placeholder="请选择监测企业"
                  allowClear
                  v-model="queryParam.companyId"
                  optionFilterProp="children"
                  showSearch
                >
                  <a-select-option v-for="(wh, whIndex) in companyList" :key="whIndex" :value="wh.id"
                  >{{ wh.companyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="行政区域">
                <a-tree-select
                  style="width: 100%"
                  :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                  :treeData="areaTree"
                  v-model="queryParam.areaId"
                  placeholder="请选择行政区域"
                  show-search
                  treeNodeFilterProp="title"
                >
                  <template slot="title" slot-scope="{ title }"> ABC{{ title }}</template>
                </a-tree-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8" v-if="userTenant=='0'">
              <a-form-item label="租户">
                <a-select optionFilterProp="children" placeholder="请选择租户" v-model="queryParam.tenantId" showSearch>
                  <a-select-option v-for="(item, key) in tenantList" :key="key" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                <j-dict-select-tag
                  :search="true"
                  dictCode="valid_status"
                  v-model="queryParam.status"
                  placeholder="请选择状态"
                >
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
      <a-button @click="searchReset" icon="reload">重置</a-button>
      <a-button type="dashed" @click="handleToggleSearch" style="margin-left: 15px; margin-right: 50px">
        {{ toggleSearchStatus ? '收起' : '展开' }}
        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
      </a-button>
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--<a-button icon="download" @click="handleExportXls()">导出</a-button>
       <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="handleImportFile" @change="handleImportExcel">
           <a-button  type="danger" icon="import" ghost>导入</a-button>
       </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">查看</a>
          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link"
            >更多
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="handleLive(record)">视频</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 视频配置 -->
    <live-device-list ref="modalLive" @ok="modalFormOk"></live-device-list>
    <!-- 表单区域 -->
    <site-info-drawer ref="modalForm" :st="root" :pagePath="pagePath" @ok="modalFormOk"></site-info-drawer>
  </div>
</template>

<script>
import SiteInfoDrawer from './modules/SiteInfoDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { queryAreaTreeList, queryDepartTreeList, queryRiverTreeList, queryUserTreeList } from '@/api/api'
import LiveDeviceList from './LiveDeviceList'

export default {
  name: 'SiteInfoList',
  mixins: [JeecgListMixin],
  components: {
    SiteInfoDrawer,
    LiveDeviceList
  },
  data() {
    return {
      showColumnState: true,
      pagePath: '/site/info',
      pageTitle: '监测站点',
      root: 0,
      riverTree: [],
      areaTree: [],
      deptTree: [],
      userTree: [],
      companyList: [],
      tenantList: [],
      userTenant: '',
      // 表头
      columns: [
        // {
        //     title: '序号',
        //     dataIndex: '',
        //     key:'rowIndex',
        //     width:60,
        //     align:"center",
        //     customRender:function (t,r,index) {
        //         return parseInt(index)+1;
        //     }
        // },
        {
          dataIndex: 'mn',
          colName: 'mn',
          title: '编号(MN)',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'name',
          colName: 'name',
          title: '名称',
          align: 'center',
          sorter: true
        },
        // {
        //   dataIndex: 'category_dictText',
        //   colName: 'category',
        //   title: '类型',
        //   align: 'center',
        //   sorter: true
        // },
        {
          dataIndex: 'departName',
          colName: 'dept_id',
          title: '运营中心',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '责任人',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'riverName',
          colName: 'river_id',
          title: '水体流域',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'areaName',
          colName: 'area_id',
          title: '行政区域',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '状态',
          align: 'center',
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: {
            customRender: 'action'
          }
        }
      ]
    }
  },
  created() {
    this.loadAllTenant()
    this.loadTree()
  },
  mounted() {
    console.log(this.queryParam.st)
    this.handleJudgeColumn()
  },
  watch: {
    $route(to, from) {
      console.log('aaa', to, from)
      this.loadData()
      this.handleJudgeColumn()
    }
  },
  computed: {},
  methods: {
    modalFormOk() {
      this.loadData()
    },
    handleJudgeColumn() {
      let oldColumns = [
        {
          dataIndex: 'mn',
          colName: 'mn',
          title: '编号(MN)',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'name',
          colName: 'name',
          title: '名称',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'departName',
          colName: 'dept_id',
          title: '运营中心',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'tenantName',
          colName: 'tenantName',
          title: '租户名称',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '责任人',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'riverName',
          colName: 'river_id',
          title: '水体流域',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'areaName',
          colName: 'area_id',
          title: '行政区域',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '状态',
          align: 'center',
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: {
            customRender: 'action'
          }
        }
      ]
      let newColumns = [
        {
          dataIndex: 'mn',
          colName: 'mn',
          title: '编号(MN)',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'name',
          colName: 'name',
          title: '名称',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'companyName',
          colName: 'companyName',
          title: '企业名称',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'departName',
          colName: 'dept_id',
          title: '运营中心',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'tenantName',
          colName: 'tenantName',
          title: '租户名称',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '责任人',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'areaName',
          colName: 'area_id',
          title: '行政区域',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '状态',
          align: 'center',
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: {
            customRender: 'action'
          }
        }
      ]
      delete this.queryParam.companyId
      let str = '31,32,35'
      if (str.indexOf(this.queryParam.st) > -1) {
        this.columns = newColumns
        this.showColumnState = false
        this.queryCompanyList()
      } else {
        this.columns = oldColumns
        this.showColumnState = true
      }
    },
    // 获取租户信息
    loadAllTenant() {
      var that = this
      that.userTenant = window.localStorage.getItem('tenant')
      that.tenantList = []
      if (that.userTenant == '0') {
        getAction('/sys/tenant/queryAllTenant').then((res) => {
          if (res.success) {
            that.tenantList = res.result
          }
        })
      }
    },
    queryCompanyList() {
      getAction('/site/company').then((res) => {
        if (res.success) {
          this.companyList = res.result.records
        }
      })
    },
    initTableData(arg) {
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      let ss = this.$route.path.split('/')
      this.root = ss[ss.length - 1]
      this.queryParam.st = this.root
      var params = this.getQueryParams() //查询条件

      this.loading = true
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.warning('系统异常=>' + res.message)
        }
        this.loading = false
      })
    },

    handleLive: function(record) {
      this.$refs.modalLive.refresh(record)
      this.$refs.modalLive.title = '编辑：站点视频'
      this.$refs.modalLive.disableSubmit = false
      this.$refs.modalLive.showTab = true
      this.$refs.modalLive.showContact = true
    },

    loadTree() {
      var that = this
      that.riverTree = []
      that.areaTree = []
      that.deptTree = []
      that.userTree = []
      // 流域
      queryRiverTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            temp.key = temp.key
            that.riverTree.push(temp)
          }
          this.loading = false
        }
      })
      // 区域
      queryAreaTreeList({
        status: '1'
      }).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            temp.key = temp.key
            that.areaTree.push(temp)
          }
          this.loading = false
        }
      })
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
          this.loading = false
        }
      })
      // 部门
      queryDepartTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.deptTree.push(temp)
          }
          this.loading = false
        }
      })
    },

    handleAdd: function() {
      let tenantId = window.localStorage.getItem('tenant')
      // 1用户 2站点
      getAction('/sys/tenant/superiorLimit/' + Number(tenantId) + '/' + 2).then((res) => {
        if (res.success) {
          if (res.result > 0 || res.result == null) {
            this.$refs.modalForm.add()
            this.$refs.modalForm.title = '新增：' + this.pageTitle
            this.$refs.modalForm.disableSubmit = false
            this.$refs.modalForm.showTab = false
            this.$refs.modalForm.showContact = false
            if (res.result > 0) {
              this.$notification.success({ message: '该租户还可以添加' + res.result + '个站点！' })
            }
          } else {
            this.$notification.warn({ message: '该租户下的站点数量已达到上限，不可再继续添加，请联系管理员！' })
          }
        }
      })
    }

  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
